<template>
  <arctic-template
    version="1.0.3"
    :primary-nav="primaryNav"
    :secondary-nav="secondaryNav"
  ></arctic-template>
</template>

<script>
export default {
  data() {
    return {
      primaryNav: [
        {
          text: "Docs",
          link: "#"
        }
      ],
      secondaryNav: [
        /*
        {
          icon: "fa-th-large",
          text: "Dashboard",
          link: "/admin/dashboard"
        },
        */
        {
          icon: "fa-align-left",
          text: "Navigation",
          link: "/navigation"
        },
        {
          icon: "fa-file-alt",
          text: "Content",
          link: "/content"
        },
        {
          icon: "fa-shopping-basket",
          text: "Stock Basket",
          link: "/stock-basket"
        },
        {
          icon: "fa-chart-line",
          text: "Patterns",
          link: "/stock-patterns"
        }
        /*
        {
          icon: "fa-users-cog",
          text: "Permissions",
          link: "/admin/users/permissions"
        },
        {
          icon: "fa-cog",
          text: "Settings",
          link: "/admin/settings"
        },
        {
          icon: "fa-chart-bar",
          text: "Reports",
          link: "/admin/reports"
        }
        */
      ]
    };
  }
};
</script>
